import {Typography, useTheme} from "@mui/material";

/**
 * Renders a message telling the user that the data list or table was empty.
 *
 * @param {string} title
 */
const DataEmptyMessage = ({title}) => {
  const theme = useTheme();

  return (
    <Typography
      variant="body1"
      sx={{
        color: theme.palette.ilblue.main,
        fontFamily: 'Montserrat',
        fontSize: theme.typography.pxToRem(16),
        fontWeight: 500,
        marginTop: '32px',
        width: '100%',
        textAlign: 'center'
      }}
    >
      {title}
    </Typography>
  );
};

export default DataEmptyMessage;
